import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { groupBy } from 'lodash';
import { CommonService } from 'src/app/Service/Common.service';
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { IProjectMemberViewModel } from 'src/app/ViewModel/MembersModel';
import { IProjectMemberByRolesOuput } from 'src/app/ViewModel/ProjectElementsModel';
import { WtfActionReassignToInputModel } from 'src/app/ViewModel/RespondWorkflowModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { WorkflowAssignedToModel } from 'src/app/ViewModel/WorkflowAssignedToModel';


@Component({
  selector: 'app-wtf-action-reassignto-dtn',
  templateUrl: './wtf-action-reassignto-dtn.component.html',
  styleUrls: ['./wtf-action-reassignto-dtn.component.css']
})


export class WtfActionReassigntoDtnComponent implements OnInit {

  projectId: number;
  groupId: number;
  successList!:WtfActionReassignToInputModel[];
  enableFullscreen = false;
  enableFilter = false;
  roleMember!:any[];
  documentSelectedMembers!:any[];
  selectedDocumentMembers: Map<number,Map<number,number[]>> = new Map<number,Map<number,number[]>>();
  roleMembersList:Map<number,any[]>=new Map<number,any[]>();
  isInitialMembers!:Boolean
  isMembersChanged:Boolean = false
  roleWiseMembersList!:IProjectMemberByRolesOuput[];
  selectedDocumentDirectMembers: Map<number,number[]> = new Map<number,number[]>();
  projectMemberList!:IProjectMemberViewModel[];
  isDisable:Boolean=false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<WtfActionReassigntoDtnComponent>,
  public _workflowTemplateService: WorkflowTemplateService,
  private _projInfoService: ProjectInfoService,
  private _commonService: CommonService,public _notificationService: NotificationService,public _memberService:ExternalMemberService) { }

  async ngOnInit(): Promise<void> {
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.successList=[...this.data['successList']];
    await this.loadPopUp();
  }

  async loadPopUp()
  {
    let assignedToMember:any[]=[];
    let selectedMessageId = new Set<number>();
    await this._memberService.GetMembersListAgainstProject({ group_Id: this.groupId, project_Id: this.projectId }).toPromise().then(memebers => {
      this.projectMemberList=memebers;
    })
    this.successList.forEach(x => {
      let assignedToRoles: WorkflowAssignedToModel[] = x.nextStepAssignedToRoles;
      if (!!assignedToRoles && assignedToRoles.length > 0)
      {
        assignedToRoles.forEach(ele => {
          assignedToMember.push({ docId: x.documentId, roleId: ele.role_Id });
          if(!selectedMessageId.has(ele.role_Id))
          {
            selectedMessageId.add(ele.role_Id);
          }
        })
      }
      let assignedToMembers:WorkflowAssignedToModel[]= x.nextStepAssignedToMember;
      if(!!assignedToMembers && assignedToMembers.length>0)
      {
        x.assignedToMemberDetails=[];
        let selectedMembers=assignedToMembers.map(member => member.member_Id);
        let obj={
          Description:'AssignedToMembers'
          ,selectedMembersIds:selectedMembers
          ,Members:this.projectMemberList
        }
        x.assignedToMemberDetails.push(obj);
        this.selectedDocumentDirectMembers.set(x.documentId,selectedMembers);
      }
    })
    let rolesIds=[...selectedMessageId].map(Number).join(",");
    
    if(selectedMessageId.size>0)
    {

      await this._projInfoService.getProjectMembersByRoles({projectId:this.projectId,groupId:this.groupId,roleIds:rolesIds}).toPromise().then(res => {
        this.roleWiseMembersList=res;
      })
      let roleWiseMembers=groupBy(this.roleWiseMembersList,'roleId');
      this._workflowTemplateService.getWorkflowMemberByRole(assignedToMember).toPromise().then((res)=>{
        let roleGroup=groupBy(res,'roleId');
        this.successList.forEach(x => {
          let assignedToRoles: WorkflowAssignedToModel[] = x.nextStepAssignedToRoles;
          if(!!assignedToRoles && assignedToRoles.length > 0)
          {
            assignedToRoles.forEach(async ele =>{
              ele.roleSelectedMembers=roleGroup[ele.role_Id].filter(val => val.docId==x.documentId).map(val1 => val1.memberId).map(Number);
              ele.roleMembers= roleWiseMembers[ele.role_Id];
              if(this.selectedDocumentMembers.has(x.documentId))
              {
                this.selectedDocumentMembers.get(x.documentId).set(ele.role_Id,ele.roleSelectedMembers);
              }
              else
              {
                let values:Map<number,number[]>=new Map<number,number[]>();
                values.set(ele.role_Id,ele.roleSelectedMembers);
                this.selectedDocumentMembers.set(x.documentId,values)
              }
              this.isInitialMembers=true;
            })
          }
        })
      })
  
    }
  }

  onChange_Member(event:any,documentDetails:WtfActionReassignToInputModel,roleId:any,index:number)
  {
 
    if(!!event)
    {
      if(this.selectedDocumentMembers.get(documentDetails.documentId).has(roleId))
      {
        this.selectedDocumentMembers.get(documentDetails.documentId).delete(roleId);
        let selectedMemberIds: number[] = event.emittingList.map((x: { value: any; }) => x.value);
        if (selectedMemberIds.length > 0)
        {
          this.selectedDocumentMembers.get(documentDetails.documentId).set(roleId, selectedMemberIds);
        }
        else{
          this.selectedDocumentMembers.get(documentDetails.documentId).set(roleId,[]);
        }
        this.isDisable=this.isValid();
      }
    }

  }

  onChange_DirectMember(event:any,documentDetails:WtfActionReassignToInputModel)
  {

    if(!!event)
    {
      if(this.selectedDocumentDirectMembers.has(documentDetails.documentId))
      {
        this.selectedDocumentDirectMembers.delete(documentDetails.documentId)
        let selectedMemberIds: number[] = event.emittingList.map((x: { value: any; }) => x.value);
        if(selectedMemberIds.length>0){
          this.selectedDocumentDirectMembers.set(documentDetails.documentId,selectedMemberIds);
        }
        else
        {
          this.selectedDocumentDirectMembers.set(documentDetails.documentId,[]);
        }
        let memberValues=documentDetails.assignedToMemberDetails
        if(memberValues && memberValues.length>0)
        memberValues[0].selectedMembersIds=selectedMemberIds && selectedMemberIds.length>0 ? selectedMemberIds:[];
        this.isDisable=this.isValid();
      }
    }
  }


  changeUser()
  {
    let newMembersToUpdate:{DocId:number,DocRevisionNo:string,RoleId:number,Members:number}[]=[];
    this.successList.forEach(x => {
      let roleMembers:WorkflowAssignedToModel[]=x.nextStepAssignedToRoles?.filter(r => r.role_Id>0);
      if(roleMembers && roleMembers.length>0)
      {
        roleMembers.forEach(y => {
          this.selectedDocumentMembers.get(x.documentId).get(y.role_Id).forEach(member =>{
            newMembersToUpdate.push({DocId:x.documentId,DocRevisionNo:x.revisionNo,RoleId:y.role_Id,Members:Number(member)});
          })
          
        })
      }
      if(x.nextStepAssignedToMember && x.nextStepAssignedToMember.length>0)
      {
        this.selectedDocumentDirectMembers.get(x.documentId).forEach(member => {
          newMembersToUpdate.push({DocId:x.documentId,DocRevisionNo:x.revisionNo,RoleId:null,Members:Number(member)});
        })
      }
    })

    let reqData: any = {
      projectId: this._commonService.getProjectId(),
      groupId: this.groupId,
      userId: this._commonService.getLoggedInUserId(),
      roleMembers: newMembersToUpdate
    }

    this._workflowTemplateService.updateWFAssignedToRoleUserBulk(reqData).subscribe((x:StandardOutputModel) => {
      if (!!x && x.successCode == 200) {
        this._notificationService.showToast(x.successMessage, "Success");   
      }
      else {
        this._notificationService.showToast("Failed to update next step user", "Warning");
      }
      this.closeDialog();
    })
  }


  closeDialog()
  {
    
    this.dialogRef.close(); 
  }

  isValid()
  {
    let isDisable!:Boolean;
    this.selectedDocumentDirectMembers.forEach(async x => {
      if(x.length==0)
      {
        isDisable= true;
      }
    })
    this.selectedDocumentMembers.forEach(x => {
      x.forEach(y => {
        if(y.length==0)
        {
          isDisable= true;
        }
      })
    })

    if(isDisable)
    return true;
    return false;
  }

}
